import { Ban, LogOut } from "lucide-react";
import { BrandLogo } from "./BrandLogo";
import { useAuth } from "../context/AuthContext";

export default function BannedScreen() {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen bg-[#F5F8FD] hero-bg flex items-center justify-center p-6">
      <div
        className="w-full max-w-md bg-[#FFFFFF]/85 backdrop-blur-xl border border-red-500/40 rounded-2xl p-8 text-center"
        data-testid="banned-screen"
      >
        <BrandLogo size={64} className="mx-auto mb-4 opacity-60" />
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-red-500/15 border border-red-500/40 mb-4">
          <Ban className="w-7 h-7 text-red-400" />
        </div>
        <h1 className="font-display text-2xl font-black text-slate-900 tracking-tighter">
          Dein Konto ist gesperrt
        </h1>
        <p className="text-sm text-slate-600 mt-3 leading-relaxed">
          Hallo {user?.name}, dein Konto wurde nach 3 Verwarnungen automatisch gesperrt.
          Bitte kontaktiere den Administrator von TSU-PARTNERS, falls du der Meinung bist,
          dass es sich um einen Irrtum handelt.
        </p>
        <a
          href="mailto:admin@tsu-partners.de"
          data-testid="banned-contact-link"
          className="inline-block mt-5 text-[#4DBFFF] font-semibold text-sm"
        >
          admin@tsu-partners.de
        </a>
        <button
          onClick={logout}
          data-testid="banned-logout-btn"
          className="mt-6 inline-flex items-center justify-center gap-2 bg-slate-100/70 hover:bg-slate-100 text-slate-900 font-semibold py-3 px-6 rounded-full transition-all"
        >
          <LogOut className="w-4 h-4" /> Abmelden
        </button>
      </div>
    </div>
  );
}
